import firebase from 'firebase'
import 'firebase/functions'
// import firestore from 'firebase/firestore'


// Initialize Firebase
var config = {
    apiKey: process.env.VUE_APP_FIREBASE_API_KEY,
    authDomain: process.env.VUE_APP_FIREBASE_AUTH_DOMAIN,
    databaseURL: process.env.VUE_APP_FIREBASE_DATABASE_URL,
    projectId: process.env.VUE_APP_FIREBASE_PROJECT_ID,
    storageBucket: process.env.VUE_APP_FIREBASE_STORAGE_BUCKET,
    messagingSenderId: process.env.VUE_APP_FIREBASE_MESSAGING_SENDER_ID
}
// Initialize Firebase only if it hasn't been initialized yet
const firebaseApp = !firebase.apps.length ? firebase.initializeApp(config) : firebase.app();

// const firebaseApp = firebase.initializeApp(config);
//firebaseApp.firestore().settings({ timestampsInSnapshots: true })

// firebaseApp.firestore().enablePersistence()

// Enable offline persistence with synchronized tabs
const firestore = firebaseApp.firestore();
const CACHE_BUSTER_KEY = 'journey_cache_buster_v1'
const CACHE_BUSTER_VERSION = '2026-08-29-slim-persist'

function enableOfflinePersistence() {
    firestore.enablePersistence({ synchronizeTabs: true })
        .catch((err) => {
            if (err.code === 'failed-precondition') {
                console.error("Multiple tabs open, persistence can only be enabled in one tab at a time.");
            } else if (err.code === 'unimplemented') {
                console.error("The current browser does not support all of the features required to enable persistence");
            }
        });
}

function runCacheBustIfNeeded() {
    if (typeof window === 'undefined' || !window.localStorage) {
        enableOfflinePersistence()
        return
    }

    const currentVersion = window.localStorage.getItem(CACHE_BUSTER_KEY)
    const shouldBust = currentVersion !== CACHE_BUSTER_VERSION

    if (!shouldBust) {
        enableOfflinePersistence()
        return
    }

    // Force a one-time refresh of stale persisted app state.
    window.localStorage.removeItem('journey_v3')
    window.localStorage.setItem(CACHE_BUSTER_KEY, CACHE_BUSTER_VERSION)

    firestore
        .clearPersistence()
        .catch((err) => {
            // Best-effort only. This can fail if another tab is open.
            console.warn('Firestore persistence clear skipped:', err?.code || err)
        })
        .finally(() => {
            enableOfflinePersistence()
        })
}

runCacheBustIfNeeded()

export { firebase };
export default firebaseApp.firestore()